webpackJsonp([59963396046441],{

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/body-language-thumbnail.cd1d7fd3.jpg";

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/build-rebuild-trust-thumbnail.a6173522.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/powerful.79e00f76.jpg";

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trust-infographic.0148ead2.png";

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trust-works-cover.40b69173.jpg";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/trust.934af8c5.png";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/why-good-leaders-thumbnail.a0ef3703.jpg";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(54);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BooksSection = __webpack_require__(40);
	
	var _BooksSection2 = _interopRequireDefault(_BooksSection);
	
	var _TalksSection = __webpack_require__(41);
	
	var _TalksSection2 = _interopRequireDefault(_TalksSection);
	
	var _powerful = __webpack_require__(480);
	
	var _powerful2 = _interopRequireDefault(_powerful);
	
	var _trustInfographic = __webpack_require__(485);
	
	var _trustInfographic2 = _interopRequireDefault(_trustInfographic);
	
	var _buildRebuildTrustThumbnail = __webpack_require__(462);
	
	var _buildRebuildTrustThumbnail2 = _interopRequireDefault(_buildRebuildTrustThumbnail);
	
	var _whyGoodLeadersThumbnail = __webpack_require__(488);
	
	var _whyGoodLeadersThumbnail2 = _interopRequireDefault(_whyGoodLeadersThumbnail);
	
	var _bodyLanguageThumbnail = __webpack_require__(460);
	
	var _bodyLanguageThumbnail2 = _interopRequireDefault(_bodyLanguageThumbnail);
	
	var _trustWorksCover = __webpack_require__(486);
	
	var _trustWorksCover2 = _interopRequireDefault(_trustWorksCover);
	
	var _trust = __webpack_require__(487);
	
	var _trust2 = _interopRequireDefault(_trust);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var books = [{
	  title: 'Powerful',
	  link: 'https://www.amazon.com/Powerful-Building-Culture-Freedom-Responsibility/dp/1939714095',
	  description: 'When it comes to recruiting, motivating, and creating great teams, Patty McCord says most companies have it all wrong. McCord helped create the unique and high-performing culture at Netflix, where she was chief talent officer. In her new book, Powerful: Building a Culture of Freedom and Responsibility, she shares what she learned there and elsewhere in Silicon Valley.',
	  image: {
	    src: _powerful2.default,
	    alt: 'Powerful book cover'
	  }
	}, {
	  title: 'Trust Works!',
	  link: 'https://www.amazon.com/dp/0062205986/ref=cm_sw_su_dp?tag=harpercollinsus-20',
	  description: 'Trust Works!: Four Keys to Building Lasting Relationships is an insightful guide designed to help people navigate one of the most complex issues that affects all areas of our lives: trust.',
	  image: {
	    src: _trustWorksCover2.default,
	    alt: 'Trust Works! book cover'
	  }
	}];
	
	var talks = [{
	  title: 'How to build and rebuild trust',
	  link: 'https://www.ted.com/talks/frances_frei_how_to_build_and_rebuild_trust',
	  description: 'Trust is the foundation for everything we do. But what do we do when it\'s broken? In an eye-opening talk, Harvard Business School professor Frances Frei gives a crash course in trust: how to build it, maintain it and rebuild it -- something she worked on during a recent stint at Uber. "If we can learn to trust one another more, we can have unprecedented human progress," Frei says.',
	  image: {
	    src: _buildRebuildTrustThumbnail2.default,
	    alt: 'How to build and rebuild trust video thumbnail'
	  }
	}, {
	  title: 'Why good leaders make you feel safe',
	  link: 'https://www.ted.com/talks/simon_sinek_why_good_leaders_make_you_feel_safe',
	  description: 'What makes a great leader? Management theorist Simon Sinek suggests, it’s someone who makes their employees feel secure, who draws staffers into a circle of trust. But creating trust and safety — especially in an uneven economy — means taking on big responsibility.',
	  image: {
	    src: _whyGoodLeadersThumbnail2.default,
	    alt: 'Why good leaders make you feel safe video thumbnail'
	  }
	}, {
	  title: 'Your body language may shape who you are',
	  link: 'https://www.ted.com/talks/amy_cuddy_your_body_language_shapes_who_you_are',
	  description: 'Body language affects how others see us, but it may also change how we see ourselves. Social psychologist Amy Cuddy argues that "power posing" — standing in a posture of confidence, even when we don\'t feel confident — can boost feelings of confidence, and might have an impact on our chances for success.',
	  image: {
	    src: _bodyLanguageThumbnail2.default,
	    alt: 'Your body language may shape who you are video thumbnail'
	  }
	}];
	
	var BuildingTrust = function BuildingTrust() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { id: 'one', className: 'main style1' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-6' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Building Trust'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ensuring that your people look upon you with respect by doing the following:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Instilling pride in people for being associated with you'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Communicate openly'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Going beyond your self-interest for the good of the group'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Keep your promises'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Acting in ways that builds others respect for you'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Being fair and reliable (authentic, transparent and honest)'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-6' },
	          _react2.default.createElement(
	            'span',
	            { className: 'image fit' },
	            _react2.default.createElement('img', { src: _trust2.default, alt: 'Group of people holding hands in sign of trust' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'four', className: 'main style3 special' },
	      _react2.default.createElement(
	        'header',
	        { className: 'major' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Check Lists'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrapper' },
	        _react2.default.createElement('div', { className: 'col-3' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-6' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'uniform', style: { listStyle: 'square', textAlign: 'left' } },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://drive.google.com/open?id=1xMDRvxfZMNoZ4WlV39QLH-TyNP-_bwyb' },
	                'How can I have the best 1:1 meetings?'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://naspers.udemy.com/active-listening/learn/v4/overview' },
	                'How can I become an active listener?'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: '#' },
	                'Do I communicate enough?'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://drive.google.com/open?id=171m2yVo-ZnyyczzdYp6v68ArbQ2fC85F' },
	                'How should I give feedback?'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { target: '_blank', href: 'https://leadingwithtrust.com/2018/06/24/do-your-leaders-build-or-erode-trust-infographic/' },
	                'Build trust model - ABCD'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement('div', { className: 'col-3' })
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'five', className: 'main style1' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-6' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Templates'
	            )
	          ),
	          _react2.default.createElement(
	            'h4',
	            null,
	            '10 ways to earn the trust and respect of your team:'
	          ),
	          _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              'Be transparent with motives and goals.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Demonstrate your character and intention to do the right thing for your team.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Put the team\'s needs before your own.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Help employees grow by letting them test, learn and fail without fear.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Trust employees of the bat, don\'t make them feel they have to earn it.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Let yourself be vulnerable, and admit to mistakes.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Use inclusive words like "we" to show that you\'re part of the team, not above it.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Ask for feedback and take action quickly where change is needed.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Be yourself - people respond best to authenticity.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Be open to learning from your team - everyone will have something to teach you.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-6' },
	          _react2.default.createElement(
	            'span',
	            { className: 'image fit' },
	            _react2.default.createElement('img', { src: _trustInfographic2.default, alt: '' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'six', className: 'main style3 special' },
	      _react2.default.createElement(
	        'header',
	        { className: 'major' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Guiding Questions'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-6' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'highlight-title-dark' },
	            'For Managers:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	              'li',
	              null,
	              'How would I describe my relationship with my team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do I feel like I can trust my team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do I feel like I can be transparent with my team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do I encourage my team to give me their opinion?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do I give my team enough freedom to decide how they can do their work?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Can I count on my team when I need help?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do I and my team collaborate together?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'How do I use 1:1 meetings to connect with my team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'On a scale of 1 to 20, how is my relationship with my team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do I feel that trust issues are affecting my team\u2019s productivity?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do I delegate important task to my team members?'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-6' },
	          _react2.default.createElement(
	            'h4',
	            { className: 'highlight-title-light' },
	            'By Manager to a Team Member:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do you feel like you can trust me?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do you feel like you can share honest thoughts with me?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Do you trust the rest of the team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'How can we improve as a team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'What can we do to make you more successful?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Is there any part of your job where you want more help or coaching?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Are you happy working here?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'How do you feel your work/life balance is right now?'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'three', className: 'main style1 special' },
	      _react2.default.createElement(
	        'div',
	        { className: 'grid-wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Learning Materials'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-4' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'What should happen in a 1:1 meeting?'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Reading: Asking open ended questions helps new managers build trust'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'MyAcademy: Active Listening Masterclass'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-4' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'What can I do to improve trust?',
	            _react2.default.createElement('br', null),
	            '\xA0\xA0\xA0\xA0\xA0\xA0'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Reading I: Want your employees to trust you? Show you trust them'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Reading II: What to do when you don\'t trust your team?'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'MyAcademy: Buildind Trust w/ Employees (by Vado)'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-4' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            'How can I assess my leadership model?'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { style: { textAlign: 'left' } },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Assessing your Leadership Mode - quiz (we should transform the quiz in an online one)'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_BooksSection2.default, { id: 'eight', books: books, darkBg: true }),
	    _react2.default.createElement(_TalksSection2.default, { id: 'seven', talks: talks })
	  );
	};
	
	exports.default = BuildingTrust;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-building-trust-js-10ad52d792ca699a3b26.js